import { useEffect, useState } from "react"
import { ProductYield } from "../../../state/types"
import { Modal, ModalId, useUIState } from "../../../../../features/ui"
import { Product } from "../../../../products"
import { ExcludedProductsForm } from "./excludedProductsForm"

type Props = {
    filterProducts?: (product: Product) => boolean
    onSubmit: (data: Partial<ProductYield>) => void
}

export const ExcludedProductsFormModal = (props: Props) => {
    const { filterProducts, onSubmit } = props

    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()

    useEffect(() => {
        if (openedModal === ModalId.EXCLUDED_PRODUCTS_FORM) {
            setKey(prev => prev + 1)
        }
    }, [openedModal])

    return (
        <Modal
            modalId={ModalId.EXCLUDED_PRODUCTS_FORM}
            title="Excluir Producto"
            actions={[]}
            widthSize="m"
        >
            <ExcludedProductsForm
                key={key}
                filterProducts={filterProducts}
                onSubmit={onSubmit}
            />
        </Modal>
    )
}